import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';
import { Site } from 'src/app/model/site';
import { AppState } from 'src/app/store/app.reducer';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { SiteDialogComponent } from '../site-dialog/site.dialog.component';
import * as SiteActions from 'src/app/store/site/site.actions';
import { GateState } from 'src/app/model/gate-state';
import { selectDevicesStatus, selectGateStates } from 'src/app/store/device/device.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { DeviceStatus } from 'src/app/model/device-status';
import { EDeviceCategory } from 'src/app/conf/device-categories';
import { Device } from 'src/app/model/device';
import { DevicesTree } from 'src/app/model/device-tree';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-device-tree',
	templateUrl: './device-tree.component.html',
	providers: [ConfirmationService, DialogService]
})
export class DeviceTreeComponent implements OnInit, OnDestroy {
	gateState$: Observable < GateState[] | undefined >;
	gateStateSub: Subscription | undefined;
	site$: Observable < Site | undefined >;
	siteSub: Subscription | undefined;
	devicesStatus$: Observable < DeviceStatus[] | undefined >;
	devicesStatusSub: Subscription | undefined;

	/* deviceModel$: Observable <DeviceModel | undefined>;
	deviceModelSub: Subscription;
	deviceModel: DeviceModel = new DeviceModel();
	iconName: string;

	deviceSub$: Observable <Device | undefined>;
	deviceSub: Subscription;
	device: Device = new Device(); */

	gateStates: GateState[];
	currentSite: Site;
	//dataSource: any;
	devicesStatus: DeviceStatus[] = [];
	gateways: Device[];

	devicesTree: DevicesTree;
	files1: TreeNode[] = [];

	ref: DynamicDialogRef | undefined;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_WIDTH_MX7 = 1700;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
		private router: Router,
		private route: ActivatedRoute,
	) {
	this.initSelectors();
	}

	ngOnInit() {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'DEVICES'
		}));

		this.setup();

		this.onCurrentSiteChange();
		this.onTreeDevicesChange();
		// this.onCurrentDeviceModel();
		// this.onCurrentDevice();

		this.onResize();
	}

	initSelectors(): void {
		// Store selectors
		this.gateState$ = this.store.select(selectGateStates);
		this.site$ = this.store.select(selectCurrentSite);
		this.devicesStatus$ = this.store.select(selectDevicesStatus);

		//this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		//this.deviceSub$ = this.store.select(selectCurrentDevice);
	}

	subscribeAll(): void {
		this.gateStateSub = this.gateState$.subscribe(gateStates => {
			this.gateStates = gateStates;
		});
	}

	ngOnDestroy(): void {
		this.store.dispatch(NotificationsActions.resetTopbarTitleId());
		this.gateStateSub?.unsubscribe();
	}

	setup(): void {
		/*this.treeFlattener = new MatTreeFlattener(
			this.transformer, node => node.level, node => node.expandable, node => node.Children);
		this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);*/

	}

	onCurrentSiteChange(): void {
		this.siteSub = this.site$.pipe(filter(currentSite => !!currentSite))
			.subscribe(currentSite => {
				this.currentSite = currentSite;
				if (currentSite.Devices.length > 0) {
					const deviceIds: number[] = currentSite.Devices.map(d => d.Id);
					this.store.dispatch(DeviceActions.getDevicesStatus({ deviceIds }));
				} else {
					//this.dataSource.data = [];
					this.devicesStatus = [];
				}
			}
		);
	}

	onTreeDevicesChange(): void {
		this.devicesStatusSub = this.devicesStatus$.pipe(filter(ds => ds.length > 0))
		.subscribe(
			devicesStatus => {
				if (!this.currentSite) {
					return;
				}
				//this.dataSource.data = [];
				this.devicesStatus = devicesStatus;
				this.devicesTree = this.currentSite.DevicesTree;
				this.generateTreeNode();
				//this.dataSource.data = this.devicesTree.Children;
				this.gateways = this.currentSite.Devices.filter(d => (
					d.CategoryId === EDeviceCategory.Gateway ||
					d.CategoryId === EDeviceCategory.SubGateway
				));
				//this.treeControl.expandAll();

			}
		);
	}

	/* onCurrentDeviceModel(): void {
		this.deviceModelSub = this.deviceModel$.pipe(filter(dm => !!dm))
			.subscribe(deviceModel => {
				this.deviceModel = deviceModel;
				if (deviceModel.Id !== EDeviceModel.MultiIO){
					this.iconName = DeviceIcon[deviceModel.Id];
				} else{
					this.iconName = this.device.IconName.toLowerCase() || DeviceIcon[deviceModel.Id] || 'qbe';
				}
			});
	} */

	/* onCurrentDevice(): void {
		this.deviceSub = this.deviceSub$.pipe(filter(d => !!d))
			.subscribe(device => {
				this.device = device;
			});
	} */

	generateTreeNode(): void {
		this.files1 = [];
		for (const children of this.devicesTree.Children) {
			this.files1.push(this.createTreeNode(children));
		}
	}

	createTreeNode(device: DevicesTree) : TreeNode {
		const child = [];
		if (device.Children !== undefined && device.Children.length > 0){
			for (const children of device.Children) {
				child.push(this.createTreeNode(children));
			}
		}
		let tree = {};
		if (device.Id) {
			tree = {label: device.Name, data: device, icon:"pi cm-devices", children: child, expanded: true};
		} else {
			tree = {label: 'NO_DEVICES', data: device, icon:"pi cm-cancel", children: child, expanded: true};
		}
		return tree;
	}

	getStatus(nodeId: number) : string {
		if (this.devicesStatus.length > 0) {
			let device : DeviceStatus;
			this.devicesStatus.forEach(dev => {
				if (dev.Id === nodeId) {
					device = dev;
				}
			});
			return ((device) ? (device.Errored) ? this.translate.instant('GENERIC_ERROR') : ( (device.Online) ? this.translate.instant('ONLINE') : this.translate.instant('OFFLINE')) : this.translate.instant('GENERIC_ERROR'));
		}
		return '';
	}

	getStatusColor(nodeId: any) : string {
		if (this.devicesStatus.length > 0) {
			let device : DeviceStatus;
			this.devicesStatus.forEach(dev => {
				if (dev.Id === nodeId) {
					device = dev;
				}
			});
			return (device!== undefined && device.Errored) ? 'warning' : ( (device!== undefined && device.Online) ? 'success' : 'danger');
		}
		return '';
	}

	selectDevice(deviceId: number): void {
		let urlRoute = '../devices/' + deviceId;
		this.router.navigate([urlRoute], { relativeTo: this.route });
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onMobile(): boolean {
		return this.screenWidth <= this.MIN_MD_WIDTH;
	}

	layoutMarginResponsive(): string {
		return (this.screenWidth >= this.MIN_WIDTH_MX7) ? "mx-7" : "mx-2";
	}

   createSite(): void {
		this.store.dispatch(SiteActions.resetAddEditSiteForm());
		this.ref = this.dialogService.open(SiteDialogComponent, {
		header: this.translate.instant('ADD_SITE'),
		width: '85vw',
		// contentStyle: { overflow: 'hidden' },
		});
   }
}
